<af-main-container #mainContainerComponent [title]="'i18n_lib_breadcrumb#SubjectId' | translate :{fraudId: subject?.id || subjectId}"
                   spinnerIds="initial"
                   [queryParamsHandling]="'merge'"
                   [filterNavigationPath]="incidentId ? 'subjects' : ''"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [customNavigateToPath]="customBackNavigation"
                   [enableScroll]="showPotentialVictimView"
                   [buttonLabel]="canShowSubjectDelete ? ('i18n_af_buttonDelete' | translate) : null"
                   buttonSpinnerId="deleting"
                   (buttonClickListener)="openDeleteItemDialog()"
                   class="w-100 h-100">
    @if (showPotentialVictimView && canShowSubjectEdit) {
        <div CustomButtons fxLayout="row" fxLayoutAlign="end center" class="mr-16">
            <ui-kit-svg class="i-24 pointer"
                        name="ic_edit"
                        (click)="editSubject()">
            </ui-kit-svg>
        </div>
    }
    @if (subject) {
        <div class="container">
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelSubjectData' | translate }}</div>
                <div class="info-container">
                    @for (field of subjectFields; track field) {
                        <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field#' + field.filedName | translate }}</div>
                        <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
                    }
                </div>
            </div>
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelCreatorData' | translate }}</div>
                <div class="info-container">
                    @for (field of creatorFields; track field) {
                        <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field#' + field.filedName | translate }}</div>
                        <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
                    }
                </div>
            </div>
            @if (showPotentialVictimView) {
                <div class="details-container creation-reason-section" fxLayout="column" fxLayoutAlign="start start">
                    <div class="w-100 pointer" fxLayout="row" fxLayoutAlign="space-between center" (click)="toggleBasis()">
                        <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelCreationReasonSection' | translate }}</div>
                        <ui-kit-svg class="i-24"
                                    [class.rotate-180]="basisExpanded"
                                    name="ic_arrow_down">
                        </ui-kit-svg>
                    </div>
                    @if (basisExpanded) {
                        <div class="info-container">
                            <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelCreationReasonSection' | translate }}</div>
                            <div class="t2 c-primary-gray-900">
                                {{ potentialVictimCategory?.creationReason
                                    ? ('i18n_af_subjectCategoryCreationReason#' + potentialVictimCategory.creationReason | translate)
                                    : '—' }}
                            </div>
                            <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelSubjectDescription' | translate }}</div>
                            <div class="t2 c-primary-gray-900">{{ potentialVictimCategory?.creationDescription || '—' }}</div>
                        </div>
                    }
                </div>
            }
        </div>
        @if (showPotentialVictimView) {
            <mat-tab-group mat-align-tabs="start" animationDuration="0"
                           class="mt-8 w-100 h-100 hide-scroll-bar scrollable-page-tabs"
                           (selectedIndexChange)="selectPotentialVictimTab($event)">
                @for (tab of potentialVictimTabs; track tab) {
                    <mat-tab [label]="(tab === 'tabRequests' ? ('i18n_af_tabRequests' | translate :{count: ''}) : ('i18n_af_' + tab | translate))"
                             class="text-center h-100">
                        <ng-template matTabContent>
                            @if (tab === 'tabContacts') {
                                <af-subject-contacts-tab class="mt-12 w-100" [subjectId]="subjectId"/>
                            } @else if (tab === 'tabCategories') {
                                <af-subject-categories-tab class="mt-12 w-100" [subjectId]="subjectId"/>
                            } @else if (tab === 'tabHistory') {
                                <af-entity-history class="mt-12 w-100"
                                                   [entityId]="subjectId"
                                                   [entityType]="EntityType.SUBJECT"
                                                   mode="full"/>
                            } @else if (tab === 'tabPhone') {
                                <af-full-table fxFlex
                                               class="mt-12"
                                               [dataSource]="datasource"
                                               emptyStateIconName="ic_empty_state_no_data"
                                               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleNoData"
                                               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleNoData"/>
                            } @else {
                                <af-full-table fxFlex
                                               class="mt-12"
                                               [dataSource]="[]"
                                               emptyStateIconName="ic_empty_state_no_data"
                                               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleNoData"
                                               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleNoData"/>
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        }
        @if (!showPotentialVictimView) {
            <mat-tab-group mat-align-tabs="start" animationDuration="0"
                           [(selectedIndex)]="selectedTabIndex"
                           (selectedIndexChange)="handleNavigation($event)"
                           class="mt-8 w-100 h-100 hide-scroll-bar">
                @for (tab of tabs; track tab) {
                    <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                        <ng-template matTabContent>
                            @if (activeTab === tab) {
                                @if (tab === 'tabCategories') {
                                    <af-subject-categories-tab class="mt-12" [subjectId]="subjectId"/>
                                } @else if (tab === 'tabHistory') {
                                    <af-entity-history class="mt-12"
                                                       [entityId]="subjectId"
                                                       [entityType]="EntityType.SUBJECT"
                                                       mode="full"/>
                                } @else {
                                    <af-full-table fxFlex
                                                   class="mt-12"
                                                   [dataSource]="datasource"
                                                   emptyStateIconName="ic_empty_state_no_data"
                                                   emptyStateTitleTranslationKey="i18n_af_emptyStateTitleNoData"
                                                   emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleNoData"/>
                                }
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    }
</af-main-container>
